import React from 'react';
import { LightPlayer } from '../../types/types';
import { IMAGES_BUCKET } from '../../configs/consts';

export interface Props {
    player: LightPlayer;
    played: string;
    compact?: boolean;
}

function CaptainCard({player, played,compact=false}:Props) {
    
    if (!player) {
        player = {firstname: '', lastname: ''};
    }
    const crownlogo = played === 'capt' ? '/images/icons/crown-gold.svg' : '/images/icons/crown-silver.svg';

    const playerimg = `${IMAGES_BUCKET}${player.firstname}-${player.lastname}.png`;
    const height = compact ? '3rem' : "4rem"

    return <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: 100, maxWidth: 100}}>
        <div style={{position: "relative", 
            backgroundImage: `url(${playerimg})`, 
            backgroundSize: "cover", 
            borderRadius: "50%", 
            height: height,
            width: height,
            border: `4px solid ${played === 'capt' ? 'gold' : 'grey'}`
        }}>
            <img src={crownlogo} style={{color: played==='capt' ? 'gold' : 'silver', position: "absolute", top: -6, right: -12, width: 24, height:24}} /> 
        </div>
        
        <b style={{textAlign: "center", fontSize: "0.75rem",lineHeight: 1.3}}>
            {player.firstname[0]}. {player.lastname}
        </b>
        
    </div>
}

export default CaptainCard;